import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  email: '',
  name: '',
  language: 'en',
  groups: [],
  nowGroup: 0,
  nowGroupFunctionsDetail: [],
  nowGroupUserFunctions: [],
  brands: [],
  nowBrand: 0,
  active: false,
  token: ''
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser (state, action) {
      const { payload } = action
      return { ...state, ...payload }
    },
    setLogout () {
      return { ...initialState }
    }
  }
})

export const { setUser, setLogout } = userSlice.actions
export default userSlice.reducer
